<!--
 * @Author: luohongbiao
 * @Date: 2022-01-05 09:51:49
 * @LastEditTime: 2022-06-10 21:01:07
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {};
  }
};
</script>

<style></style>
